import { render, staticRenderFns } from "./ManageMinusPoint.vue?vue&type=template&id=01115eca&scoped=true"
import script from "./ManageMinusPoint.vue?vue&type=script&lang=js"
export * from "./ManageMinusPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01115eca",
  null
  
)

export default component.exports